// src/app/plants/plant-list.component.ts
import {
    Component,
    Output,
    EventEmitter,
    ChangeDetectionStrategy
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCardModule } from '@angular/material/card';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'app-plant-list',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        RouterModule,

        // Material
        MatTableModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatCardModule
    ],
    templateUrl: './plant-list.component.html',
    styleUrls: ['./plant-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    animations: [
        trigger('fadeUp', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(10px)' }),
                animate(
                    '320ms cubic-bezier(.22,.61,.36,1)',
                    style({ opacity: 1, transform: 'translateY(0)' })
                )
            ])
        ]),
        trigger('fadeDown', [
            transition(':enter', [
                style({ opacity: 0, transform: 'translateY(-8px)' }),
                animate(
                    '320ms cubic-bezier(.22,.61,.36,1)',
                    style({ opacity: 1, transform: 'translateY(0)' })
                )
            ])
        ])
    ]
})
export class PlantListComponent {
    ownerCtrl = new FormControl<string>('', { nonNullable: true });

    @Output() searchSubmit = new EventEmitter<string>();

    submit() {
        const q = (this.ownerCtrl.value ?? '').trim();
        if (!q) return;
        this.searchSubmit.emit(q);
    }
}
